import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './DestinationChildren.module.scss';
import Link from 'next/link';

function DestinationChildren({ destinations, children, className, ...props }) {
    if (!destinations) {
        return null;
    }
    return (
        <ul
            className={classNames(styles.destinationChildren, className)}
            {...props}
        >
            {destinations.map((d) => (
                <li key={d.slug}>
                    <Link href={d.url}>
                        <a>{d.title}</a>
                    </Link>
                    <DestinationChildren destinations={d.children} />
                </li>
            ))}
            {!!children && children}
        </ul>
    );
}

DestinationChildren.propTypes = {
    className: PropTypes.string,
};

export default DestinationChildren;
